import { REACT_APP_VERSION } from '../constants';

/**
 * Request header carrying the FE build version, read by the backend's activity
 * recording (`readClientVersion` in its `clientIdentity.ts`, TMDXNC-362).
 *
 * A CUSTOM header, so every cross-origin request it rides on triggers a CORS
 * preflight — and that preflight FAILS unless the backend lists this exact name in
 * `allowedHeaders`. Getting the ordering wrong therefore does not degrade the
 * frontend, it breaks every cross-origin request outright: TMDXNC-362 must be
 * deployed to an environment before this frontend is.
 */
export const CLIENT_VERSION_HEADER = 'X-Client-Version';

/**
 * `{ 'X-Client-Version': '3.11.0' }`, or `{}` when this build has no version.
 *
 * Spreadable, so each call site is one expression and no site repeats the empty
 * check: an absent version becomes an ABSENT HEADER rather than an empty one.
 * `.env` sets `REACT_APP_VERSION=$npm_package_version`, substituted by npm, so the
 * value is `''` whenever Vite runs outside an npm script — and nothing warns,
 * because `vite.config.ts` defines a `|| ''` fallback and the `.d.ts` types it
 * `string`. An `''` recorded on an activity row is worse than a null: it looks
 * like an answer. There is deliberately no fallback value either; an invented
 * version would be indistinguishable from a real one.
 *
 * The version is a parameter with a default so both branches are testable by
 * argument, without mocking the constants barrel.
 */
export const clientVersionHeaders = (
  version: string | undefined = REACT_APP_VERSION,
): Record<string, string> => {
  const trimmed = version?.trim();

  return trimmed ? { [CLIENT_VERSION_HEADER]: trimmed } : {};
};
